module.exports = __webpack_public_path__ + "3_17_13_21_27/img/mine-information-bj.40c4054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine-information-bj.png
// module id = j25o
// module chunks = 1